import React, { useMemo } from "react";
import Select from "react-select";
import FormErrorMessage from "components/ErrorMessage/FormErrorMessage";

const FinTaxMasterSelect = ({
  formik,
  fieldName = "fin_tax_master_id",
  allTaxMasters = [],
  filters = {},
  loading = false,
  placeholder = "Select Tax Master",
  showDetails = false,
}) => {
  // ✅ Filter only relevant tax masters in-memory

  const taxList = useMemo(() => {
    return allTaxMasters
      .filter((tax) => {
        return Object.entries(filters).every(([key, val]) => tax[key] === val);
      })
      .map((tax) => ({
        value: tax.id,
        label: `${tax.code} - ${tax.name}`,
        taxData: tax,
      }));
  }, [allTaxMasters, filters]);

  const handleChange = (selectedOption) => {
    formik.setFieldValue(
      fieldName,
      selectedOption ? selectedOption.value : null
    );
    // formik.setFieldValue(
    //   "selected_tax_master",
    //   selectedOption ? selectedOption.taxData : null
    // );
  };

  return (
    <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full">
      <Select
        options={taxList}
        value={
          taxList.find((opt) => opt.value === formik.values[fieldName]) || null
        }
        onChange={handleChange}
        isLoading={loading}
        placeholder={placeholder}
        className="bg-white-A700 border border-gray-200_02 text-sm border-solid h-9 rounded-[5px] w-full"
        onBlur={() => formik.setFieldTouched(fieldName, true)}
        styles={customStyles}
      />

      {formik.touched[fieldName] && formik.errors[fieldName] && (
        <FormErrorMessage message={formik.errors[fieldName]} />
      )}

      {/* {showDetails && formik.values.selected_tax_master && (
        <div className="bg-gray-50 border text-xs border-gray-200 rounded-md p-3 mt-2 w-full space-y-1">
          {[
            { label: "Code", value: formik.values.selected_tax_master.code },
            { label: "Name", value: formik.values.selected_tax_master.name },
            {
              label: "Rate (%)",
              value: formik.values.selected_tax_master.percentageRate,
            },
            {
              label: "Calculation Type",
              value: formik.values.selected_tax_master.calculationType,
            },
            {
              label: "Reverse Charge",
              value: formik.values.selected_tax_master.reverseChargeApplicable
                ? "Yes"
                : "No",
            },
          ]
            .filter((item) => item.value !== undefined && item.value !== null)
            .map((item, idx) => (
              <p key={idx}>
                <strong>{item.label}:</strong> {item.value}
              </p>
            ))}
        </div>
      )} */}
    </div>
  );
};

export default FinTaxMasterSelect;

// 🎨 Custom Styles
const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: "36px",
    height: "36px",
    borderRadius: "5px",
    fontSize: "0.875rem",
  }),
  dropdownIndicator: (provided) => ({ ...provided, padding: 4 }),
  clearIndicator: (provided) => ({ ...provided, padding: 4 }),
  valueContainer: (provided) => ({ ...provided, padding: "0 8px" }),
  input: (provided) => ({ ...provided, margin: 0, padding: 0 }),
  menu: (provided) => ({ ...provided, borderRadius: "5px", zIndex: 9999 }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "200px",
    overflowY: "auto",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#EEF2FF" : "#FFFFFF",
    color: "#111827",
    padding: 8,
  }),
  placeholder: (provided) => ({ ...provided, color: "#6B7280" }),
};
